module.exports = __webpack_public_path__ + "static/media/Remote and Hybrid Roles.d50bceed.png";